"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const app_1 = __importDefault(require("../app"));
class DynamicForm {
    constructor(_app) {
        this._app = _app;
        this.dynamicFormChanged = (form, event) => {
            const field = (0, jquery_1.default)(event.target);
            const fieldName = field.attr("name");
            if (!fieldName) {
                return;
            }
            const data = {
                _dynamic: true,
                [fieldName]: field.val()
            };
            form.find(".dynamic-form-value :input, :input.dynamic-form-value").each((_, otherFieldNode) => {
                const otherField = (0, jquery_1.default)(otherFieldNode);
                const otherFieldName = otherField.attr("name");
                if (otherFieldName) {
                    if (!otherField.is('input[type="radio"], input[type="checkbox"]') || otherField.is(":checked")) {
                        data[otherFieldName] = otherField.val();
                    }
                }
            });
            const self = this;
            jquery_1.default.ajax({
                url: form.attr("action") || window.location.href,
                type: form.attr("method"),
                data,
                success(html) {
                    form.html((0, jquery_1.default)(html).find(`form[name="${form.attr("name")}"]`).html());
                    const formNode = form.get(0);
                    if (formNode) {
                        self._app.partialInit(formNode);
                    }
                }
            });
        };
    }
    init() {
        this.forms = (0, jquery_1.default)("form:has(.dynamic-form-modifier)");
        if (this.forms.length === 0) {
            this.forms = undefined;
            return;
        }
        this.forms.each((index, form) => {
            const $form = (0, jquery_1.default)(form);
            $form.on("change", ".dynamic-form-modifier :input, :input.dynamic-form-modifier", event => this.dynamicFormChanged($form, event));
        });
    }
    destroy() {
        if (!this.forms) {
            return;
        }
        this.forms.each((index, form) => {
            (0, jquery_1.default)(form).off("change", ".dynamic-form-modifier :input, :input.dynamic-form-modifier");
        });
        this.forms = undefined;
    }
}
exports.default = DynamicForm;
app_1.default.loadAndRegister("DynamicForm", (app) => new DynamicForm(app));
